export default "__VITE_ASSET__DuR2aEjs__"